import { Form, type SelectItemProperties } from 'ui';
import type { CommunitySelectProperties } from 'features/communities';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { CommunitySelect } from 'features/communities/components';
import { type CommunityOption, useEventCommunityCreateOption } from './hooks';

export type { CommunityOption } from './hooks';

type P = {
  input?: Omit<
    CommunitySelectProperties<CommunityOption>,
    'createOption' | 'getOptionLabel' | 'getOptionValue' | 'options'
  >;
  item?: SelectItemProperties;
};

const EventCommunity = ({ input, item }: P) => {
  const createOption = useEventCommunityCreateOption();

  return (
    <Form.Item<CommunityOption> name="community" {...item}>
      <CommunitySelect<CommunityOption> createOption={createOption} {...input} />
    </Form.Item>
  );
};

export default EventCommunity;
